import { render, staticRenderFns } from "./reply-to.vue?vue&type=template&id=7b4e9b0a&scoped=true"
import script from "./reply-to.vue?vue&type=script&lang=js"
export * from "./reply-to.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4e9b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4e9b0a')) {
      api.createRecord('7b4e9b0a', component.options)
    } else {
      api.reload('7b4e9b0a', component.options)
    }
    module.hot.accept("./reply-to.vue?vue&type=template&id=7b4e9b0a&scoped=true", function () {
      api.rerender('7b4e9b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/settings/reply-to.vue"
export default component.exports